export enum Exam {
  ISEE = "ISEE",
  SSAT = "SSAT",
  SAT = "SAT",
  ACT = "ACT",
}
